import { Color } from "@starrez/starryui";
import styled from "styled-components";

export interface IAttachmentItemWrapperStyleProps {
    Disabled?: boolean;
}

export const AttachmentItemLi = styled.li<IAttachmentItemWrapperStyleProps>`
    background: ${Color.Grey.G10};
    border-radius: 4px;
    font-size: 14px !important;
    padding: 8px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;

    ${(props) => props.Disabled && `
        opacity: 0.4;
        pointer-events: none;
    `}

    &:not(:last-child) {
        margin-bottom: 5px;
    }
`;

export const AttachmentName = styled.span`
    flex: 1;
    padding-right: 10px;
    color: ${Color.Blue.B60};
    white-space: nowrap;
    min-width: 0;
    text-overflow: ellipsis;
    overflow: hidden;
`;

export const AttachmentSize = styled.span`
    flex: 0;
    margin: 0 10px;
    flex-wrap: nowrap;
    white-space: nowrap;
    color: ${Color.Grey.G80};
`;

export const AttachmentStatus = styled.span`
    flex: 0;
`;
